import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

export default function MembersTab({ members }) {
  return (
    <Card className="mt-4 border-black/5">
      <CardContent className="p-0 overflow-x-auto">
        <table className="w-full text-sm min-w-[640px]" data-testid="admin-members-table">
          <thead className="bg-[color:var(--bg-secondary)] text-left">
            <tr><th className="p-3">Name</th><th className="p-3">Email</th><th className="p-3">Intent</th><th className="p-3">Source</th><th className="p-3">Membership</th><th className="p-3">Joined</th></tr>
          </thead>
          <tbody>
            {members.map((m) => (
              <tr key={m.user_id} className="border-t border-black/5">
                <td className="p-3">{m.name}</td>
                <td className="p-3">{m.email}</td>
                <td className="p-3 capitalize">{m.role_intent || "homeowner"}</td>
                <td className="p-3 capitalize text-xs text-[color:var(--text-secondary)]" data-testid={`admin-member-source-${m.user_id}`}>
                  {(m.heard_about || "").replace(/_/g, " ") || "—"}
                </td>
                <td className="p-3">{m.membership_active ? <Badge className="bg-[color:var(--bright-green)] text-white">Active</Badge> : <Badge variant="outline" className="border-black/10">Inactive</Badge>}</td>
                <td className="p-3 text-xs">{new Date(m.created_at).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {members.length === 0 && <p className="p-4 text-sm text-[color:var(--text-secondary)]">No members.</p>}
      </CardContent>
    </Card>
  );
}
